import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import DiscreteSliderSteps from './DiscreteSliderSteps';
import ClientProvider from './client';
export default createDemo(import.meta.url, DiscreteSliderSteps, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/slider/demos/discrete-steps/DiscreteSliderSteps.tsx",
    "fileName": "DiscreteSliderSteps.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport Slider from '@mui/material/Slider';\n\nfunction valuetext(value: number) {\n  return `${value}°C`;\n}\n\nexport default function DiscreteSliderSteps() {\n  return (\n    <Box sx={{ width: 300 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Slider\n        aria-label=\"Small steps\"\n        defaultValue={0.00000005}\n        getAriaValueText={valuetext}\n        step={0.00000001}\n        marks\n        min={-0.00000005}\n        max={0.0000001}\n        valueLabelDisplay=\"auto\"\n      />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 23,
        "focusedLines": 10,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport Slider from '@mui/material/Slider';\n\nfunction valuetext(value: number) {\n  return `${value}°C`;\n}\n\nexport default function DiscreteSliderSteps() {\n  return (\n    <Box sx={{ width: 300 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Slider\n        aria-label=\"Small steps\"\n        defaultValue={0.00000005}\n        getAriaValueText={valuetext}\n        step={0.00000001}\n        marks\n        min={-0.00000005}\n        max={0.0000001}\n        valueLabelDisplay=\"auto\"\n      />\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Slider"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "aria-label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Small steps",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "defaultValue"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "0.00000005"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "getAriaValueText"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "valuetext"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "step"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "0.00000001"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "marks"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "min"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-k di-pu",
                "-"
              ],
              [
                "span",
                "pl-c1 di-num",
                "0.00000005"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "max"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "0.0000001"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "valueLabelDisplay"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "auto",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            "      />"
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 23,
    "focusedLines": 10,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/Slider"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
